import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { IDurations } from '../types/interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faCheckCircle, faCog } from '@fortawesome/free-solid-svg-icons';

import { Calendar, DateRangePicker } from 'react-date-range';
// import { fr as dateRangeLocale } from 'react-date-range/dist/locale';
import {
  defaultStaticRanges,
  defaultInputRanges
} from "react-date-range/dist/defaultRanges";
import dateRangeLocale from "date-fns/locale/fr";
import { addDays } from 'date-fns';
import { constants } from '../types/constants';

export default function Durations({
  selectedDuration,
  setSelectedDuration,
  style
}: IDurations) {
  const durations = [{key: "", display: "Tout afficher"}, {key: constants.DURATIONS.TODAY, display: "Aujourd'hui"}, {key: constants.DURATIONS.YESTERDAY, display: "Hier"}/*, {key: "3 DAYS", display: "3 jours"}*/, {key: constants.DURATIONS._7_DAYS, display: "7 jours"}, {key: constants.DURATIONS._30_DAYS, display: "30 jours"}, {key: constants.DURATIONS.THIS_MONTH, display: "Ce mois-ci"}];
  const [modal, setModal] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      // endDate: moment().add(7, 'days'),
      endDate: addDays(new Date(), 7),
      key: 'selection'
    }
  ]);
  const staticRangesLabels = {
    "Today": "Aujourd'hui",
    "Yesterday": "Hier",
    "This Week": "Cette Semaine",
    "Last Week": "La Semaine dernière",
    "This Month": "Ce Mois-ci",
    "Last Month": "Le Mois Dernier"
  };
  
  const inputRangesLabels = {
    "days up to today": "jours jusqu'à aujourd'hui",
    "days starting today": "jours à partir d'aujourd'hui"
  };
  
  function translateRange(dictionary) {
    return (item) =>
      dictionary[item.label] ? { ...item, label: dictionary[item.label] } : item;
  }
  
  const frStaticRanges = defaultStaticRanges.map(translateRange(staticRangesLabels));
  const frInputRanges = defaultInputRanges.map(translateRange(inputRangesLabels));
  
  const handleToggle = () => setModal(!modal);

  const daterangeConfirm = () => {
    if(!dateRange?.length)
      return
    setSelectedDuration({isCustom: 1, from: dateRange[0].startDate, to: dateRange[0].endDate});
    setModal(false);
  }
  
  return (<>
    <Container className="durationsContainer fullFlexCenter" style={style || {}}>
      <Row style={{flex: 1}}>
        {durations.map((e, key) => 
          <Col xs="6" md="2" key={key}>
            <div className={`durationDiv${e.key === selectedDuration ? " active" : ""}`} onClick={() => setSelectedDuration(e.key)}>{e.display}</div>
          </Col>
        )}
      </Row>
      <div className={`durationDiv${selectedDuration.isCustom ? " active" : ""} durationCog`} onClick={() => setModal(true)}><FontAwesomeIcon icon={faCog} /></div>
    </Container>
    <Modal isOpen={modal} toggle={handleToggle} className="modal-date-range">
      <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faCalendarAlt} />&nbsp;&nbsp;Sélection des dates</ModalHeader>
      <ModalBody>
        <div className="linesConfirmationContainer">
          <div className="dateRangeDiv">
            <DateRangePicker
              onChange={item => setDateRange([item.selection])}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={dateRange}
              direction="horizontal"
              rangeColors={["#62af42"]}
              locale={dateRangeLocale}
              staticRanges={frStaticRanges}
              inputRanges={frInputRanges}
            />
          </div>
          <div className="fullFlexCenter">
            <Col xs="11" md="5">
              <Button
                className={`btn btn-success linesConfirmationBtn linesDeleteBtn`}
                style={{width: "100%"}}
                onClick={daterangeConfirm}
                ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;Choisir</Button>
            </Col>
          </div>
        </div>
      </ModalBody>
    </Modal>
  </>);
}
